export default "__VITE_ASSET__530da0bc__"